export const normalizeTo13Digits = (timestamp) => {
  if (timestamp === null || timestamp === undefined) {
    return timestamp;
  }
  const timestampStr = String(timestamp);
  if (timestampStr.length === 10) {
    return timestamp * 1000;
  }
  return timestamp;
};

export const normalizeNotificationTimestamps = (timestamps) => {
  if (!Array.isArray(timestamps)) {
    return timestamps;
  }
  return timestamps.map(normalizeTo13Digits);
};
